import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const KEY = "aa_seen_welcome_v1";

export default function WelcomeModal() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const seen = window.localStorage.getItem(KEY);
    if (!seen) setOpen(true);
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(KEY, "1");
    setOpen(false);
  };
  const dismissAndGo = () => {
    window.localStorage.setItem(KEY, "1");
    setOpen(false);
    nav("/how-it-works");
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40 bg-black/40 flex items-end md:items-center justify-center p-0 md:p-6" data-testid="welcome-modal">
      <div className="bg-[var(--aa-bg)] w-full max-w-lg rounded-t-2xl md:rounded-2xl border border-[var(--aa-elevated)] shadow-xl p-7 lg:p-9">
        <div className="aa-eyebrow mb-3">Welcome to Ageless Alchemy Protocol Companion</div>
        <div className="font-display text-3xl leading-snug">
          A quick orientation, then we'll <span className="serif-italic">get you started</span>.
        </div>
        <p className="mt-4 text-[var(--aa-text-2)] leading-relaxed">
          This Companion guides you through Dr. Rey's Ageless Alchemy skincare protocols.
          Want a 60-second overview of how this works and what to expect?
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <button onClick={dismissAndGo} data-testid="welcome-cta-tour" className="aa-cta-primary">Show me the overview →</button>
          <button onClick={dismiss} data-testid="welcome-cta-skip" className="aa-cta-secondary">Skip, I'll explore</button>
        </div>
      </div>
    </div>
  );
}
